<!-- ERM-12293 — full linked-item list for composer drafts and sent messages. -->
<wcg-dialog
  title="Linked items"
  [size]="dialogSize"
  data-testid="collab-hub-composer-attachments-dialog"
>
  <div content>
    <ul
      class="composer-attachments-dialog__list"
      data-testid="collab-hub-composer-attachments-dialog__list"
    >
      @for (chip of chips(); track chip.id) {
        <li
          class="composer-attachments-dialog__item"
          data-testid="collab-hub-composer-attachments-dialog__item"
        >
          @if (chip.isMissing) {
            <div
              class="composer-attachments-dialog__open composer-attachments-dialog__open--missing"
              data-testid="collab-hub-composer-attachments-dialog__missing"
              matTooltip="This document is no longer on the submission"
            >
              <mat-icon [svgIcon]="icons.PAPERCLIP" />
              <span class="composer-attachments-dialog__label">{{
                chip.title
              }}</span>
            </div>
          } @else if (chip.isReplaced) {
            <div
              class="composer-attachments-dialog__open composer-attachments-dialog__open--missing"
              data-testid="collab-hub-composer-attachments-dialog__replaced"
              matTooltip="This document has been replaced"
            >
              <mat-icon [svgIcon]="icons.PAPERCLIP" />
              <span class="composer-attachments-dialog__label">{{
                chip.title
              }}</span>
            </div>
          } @else {
            <button
              type="button"
              class="composer-attachments-dialog__open"
              data-testid="collab-hub-composer-attachments-dialog__open"
              [attr.aria-label]="'Open ' + chip.title"
              [disabled]="disabled"
              [matTooltip]="chip.title"
              (click)="openLinkedItem(chip)"
            >
              <mat-icon
                [svgIcon]="
                  chip.kind === 'todo'
                    ? icons.PENDING_ACTIONS_OUTLINED
                    : icons.PAPERCLIP
                "
              />
              <span
                class="composer-attachments-dialog__label"
                [class.composer-attachments-dialog__label--done]="chip.isDone"
                >{{ chip.title }}</span
              >
            </button>
          }
          @if (canRemove) {
            <button
              type="button"
              class="composer-attachments-dialog__remove"
              data-testid="collab-hub-composer-attachments-dialog__remove"
              [attr.aria-label]="'Remove ' + chip.title"
              [disabled]="disabled"
              (click)="removeLinkedItem(chip)"
            >
              &#10005;
            </button>
          }
        </li>
      } @empty {
        <li
          class="composer-attachments-dialog__empty"
          data-testid="collab-hub-composer-attachments-dialog__empty"
        >
          No linked items.
        </li>
      }
    </ul>
  </div>
  <div primary>
    <wcg-button
      color="primary"
      data-testid="collab-hub-composer-attachments-dialog__done"
      (click)="close()"
      >Done</wcg-button
    >
  </div>
</wcg-dialog>
